module.exports = "<div class=\"picker-wrapper\">\n  <div type=\"color\" class=\"picker\">\n</div>\n"